<template>
	<modal-box @close="onClose" header="Send Invitation">
		<span slot="header">{{ $t('labels.general.send_invitation') }}</span>
		<form @submit.prevent="validateAndSubmit">
			<input-text v-model="model.name" name="staff_name" :placeholder="$t('labels.general.name')" rules="required"/>
			<input-text v-model="model.email" name="staff_email" :placeholder="$t('labels.general.email')" rules="required|email"/>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="form.loading" icon="save">{{ $t('labels.general.send') }}</button-submit-icon-text>
			</div>
		</form>
	</modal-box>
</template>

<script>
export default {
	props: [
		'user_uid'
	],
	data () {
		return {
			model: {
				name: '',
				email: ''
			},
			form: {
				loading: false,
				error: null
			}
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll().then(result => {
				if (result) this.addInvitation()
			})
		},
		addInvitation () {
			this.form.loading = true
			this.$api.invitations.add(this, this.user_uid, this.model)
			.then(response => {
				// this.$log.info('watch pillbox', 'pillbox.add OK', response)()
				this.$root.$emit('add-floating-box', { type: 'success', title: 'Success', message: 'Invitation sent.' })
				this.onClose()
			})
			.catch(error => {
				// this.$log.error('watch pillbox', 'pillbox.add ERROR', error)()
				this.form.error = error
				this.$root.$emit('add-floating-box', { type: 'error', title: 'Error', message: 'Issue try to sent invitation. Try again please.' })
			})
			.finally(() => {
				this.form.loading = false
			})
		},
		onClose () {
			this.$router.push({ name: 'UserProfileStaffInvitations' })
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/staff/StaffInvitationSendForm.vue